module.exports = __webpack_public_path__ + "static/oil-steel-3642d994d4643786ebc970a5cb1cbcf1.webp";